/* eslint-disable react/no-unescaped-entities */
import { Fragment, useEffect, useRef, useState } from "react";
import { FiPhoneCall } from "react-icons/fi";
import { TfiEmail, TfiLocationPin } from "react-icons/tfi";
import logo from "../../assets/homepage/IISPL_logo.png";
import ourProfilePdf from "../../assets/our_profile.pdf";
import { NavLink } from "react-router-dom";

const Header = () => {
  // Burger menus
  const [active, setActive] = useState(false);
  const navMenuBtn = useRef();
  const navMenu = useRef();

  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    // Function to handle the scroll event
    const handleScroll = () => {
      // Determine the scroll distance when the header should become sticky
      const scrollThreshold = 160; // Adjust this value as needed

      // Check if the scroll distance is greater than the threshold
      if (window.scrollY > scrollThreshold) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    // Add the scroll event listener when the component mounts
    window.addEventListener("scroll", handleScroll);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleClick = () => {
    setActive((active) => !active);
  };

  return (
    <div className="bg-[#fff]">
      <header className={`xl:container header mx-auto px-[15px] xl:px-0 `}>
        <nav className="flex justify-between items-center mt-10 mb-1">
          <a className="text-lg font-semibold" href="/">
            <img
              className="w-full h-full max-w-[164px]"
              src={logo}
              alt=""
              width="auto"
            />
          </a>
          <div className="hidden xl:flex font-roboto">
            <div className="flex flex-wrap me-10">
              <div className="w-[55px] h-[55px] flex justify-center items-center rounded-full bg-light-blue-300 me-2">
                <FiPhoneCall size="25" color="#000066" />
              </div>
              <div>
                <h5 className="text-[19px] font-medium tracking-[1px] mb-1">
                  Telephone
                </h5>
                <h6 className="font text-grey text-[15px]">+88-02-48811446</h6>
              </div>
            </div>
            <div className="flex flex-wrap me-10">
              <div className="w-[55px] h-[55px] flex justify-center items-center rounded-full bg-light-blue-300 me-2">
                <TfiEmail size="25" color="#000066" />
              </div>
              <div>
                <h5 className="text-[19px] font-medium tracking-[1px] mb-1">
                  Email Address
                </h5>
                <h6 className=" text-grey text-[15px]">info@iisplbd.com</h6>
              </div>
            </div>
            <div className="flex flex-wrap me-10">
              <div className="w-[55px] h-[55px] flex justify-center items-center rounded-full bg-light-blue-300 me-2">
                <TfiLocationPin size="25" color="#000066" />
              </div>
              <div>
                <h5 className="text-[19px] font-medium tracking-[1px] mb-1">
                  Office Address
                </h5>
                <h6 className="text-grey text-[15px]">
                  House: 169, Road 03, Mohakhali DOHS, Dhaka
                </h6>
              </div>
            </div>
            <a href={ourProfilePdf} download className="group relative flex items-center text-[19px] font-medium tracking-[1px] mb-1 border rounded-lg px-3 py-2 h-fit bg-blue-400 text-white-#fff transition duration-300">
              <svg className=" fill-white-#fff me-2" width="30px" height="30px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" >
                <g id="SVGRepo_bgCarrier" stroke-width="0" />
                <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" />
                <g id="SVGRepo_iconCarrier"> <path d="M12 6.25C12.4142 6.25 12.75 6.58579 12.75 7V12.1893L14.4697 10.4697C14.7626 10.1768 15.2374 10.1768 15.5303 10.4697C15.8232 10.7626 15.8232 11.2374 15.5303 11.5303L12.5303 14.5303C12.3897 14.671 12.1989 14.75 12 14.75C11.8011 14.75 11.6103 14.671 11.4697 14.5303L8.46967 11.5303C8.17678 11.2374 8.17678 10.7626 8.46967 10.4697C8.76256 10.1768 9.23744 10.1768 9.53033 10.4697L11.25 12.1893V7C11.25 6.58579 11.5858 6.25 12 6.25Z" /> <path d="M7.25 17C7.25 16.5858 7.58579 16.25 8 16.25H16C16.4142 16.25 16.75 16.5858 16.75 17C16.75 17.4142 16.4142 17.75 16 17.75H8C7.58579 17.75 7.25 17.4142 7.25 17Z" /> <path fill-rule="evenodd" clip-rule="evenodd" d="M11.9426 1.25C9.63423 1.24999 7.82519 1.24998 6.4137 1.43975C4.96897 1.63399 3.82895 2.03933 2.93414 2.93414C2.03933 3.82895 1.63399 4.96897 1.43975 6.41371C1.24998 7.82519 1.24999 9.63423 1.25 11.9426V12.0574C1.24999 14.3658 1.24998 16.1748 1.43975 17.5863C1.63399 19.031 2.03933 20.1711 2.93414 21.0659C3.82895 21.9607 4.96897 22.366 6.4137 22.5603C7.82519 22.75 9.63423 22.75 11.9426 22.75H12.0574C14.3658 22.75 16.1748 22.75 17.5863 22.5603C19.031 22.366 20.1711 21.9607 21.0659 21.0659C21.9607 20.1711 22.366 19.031 22.5603 17.5863C22.75 16.1748 22.75 14.3658 22.75 12.0574V11.9426C22.75 9.63423 22.75 7.82519 22.5603 6.41371C22.366 4.96897 21.9607 3.82895 21.0659 2.93414C20.1711 2.03933 19.031 1.63399 17.5863 1.43975C16.1748 1.24998 14.3658 1.24999 12.0574 1.25H11.9426ZM3.9948 3.9948C4.56445 3.42514 5.33517 3.09825 6.61358 2.92637C7.91356 2.75159 9.62177 2.75 12 2.75C14.3782 2.75 16.0864 2.75159 17.3864 2.92637C18.6648 3.09825 19.4355 3.42514 20.0052 3.9948C20.5749 4.56445 20.9018 5.33517 21.0736 6.61358C21.2484 7.91356 21.25 9.62178 21.25 12C21.25 14.3782 21.2484 16.0864 21.0736 17.3864C20.9018 18.6648 20.5749 19.4355 20.0052 20.0052C19.4355 20.5749 18.6648 20.9018 17.3864 21.0736C16.0864 21.2484 14.3782 21.25 12 21.25C9.62177 21.25 7.91356 21.2484 6.61358 21.0736C5.33517 20.9018 4.56445 20.5749 3.9948 20.0052C3.42514 19.4355 3.09825 18.6648 2.92637 17.3864C2.75159 16.0864 2.75 14.3782 2.75 12C2.75 9.62178 2.75159 7.91356 2.92637 6.61358C3.09825 5.33517 3.42514 4.56445 3.9948 3.9948Z" /> </g>

              </svg>
              <span>Our Profile</span>
            </a>
          </div>

          <div className="flex xl:hidden justify-between items-center">
            <button
              onClick={handleClick}
              ref={navMenuBtn}
              className="navbar-burger flex items-center p-3 hover:bg-gray-50 rounded"
            >
              <svg
                className="block h-4 w-4"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <title>Mobile menu</title>
                <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z"></path>
              </svg>
            </button>

            <ul
              ref={navMenu}
              className={`${active ? "block custom_position_nav" : "hidden"
                } xl:flex xl:ml-auto xl:mr-12 xl:items-center xl:w-auto xl:space-x-12`}
            >
              <NavLink
                className="text-[14px] font-roboto uppercase font-bold text-dark-blue "
                to="/"
              >
                <li className="py-[15px] border-b-[1px] border-dark-blue-200">
                  Home
                </li>
              </NavLink>

              <li className="py-[15px] border-b-[1px] border-dark-blue-200">
                <NavLink
                  className="text-[14px] font-roboto uppercase font-bold text-dark-blue "
                  to="/about-us"
                >
                  About Us
                </NavLink>
              </li>
              <li className="py-[15px] border-b-[1px] border-dark-blue-200">
                <NavLink
                  className="text-[14px] font-roboto uppercase font-bold text-dark-blue "
                  to="/services/inspection"
                >
                  Inspection
                </NavLink>
              </li>
              <li className="py-[15px] border-b-[1px] border-dark-blue-200">
                <NavLink
                  className="text-[14px] font-roboto uppercase font-bold text-dark-blue "
                  to="/services/calibration"
                >
                  Calibration
                </NavLink>
              </li>
              <li className="py-[15px] border-b-[1px] border-dark-blue-200">
                <NavLink
                  className="text-[14px] font-roboto uppercase font-bold text-dark-blue "
                  to="/services/testing"
                >
                  Testing Services
                </NavLink>
              </li>
              <li className="py-[15px] border-b-[1px] border-dark-blue-200">
                <NavLink
                  className="text-[14px] font-roboto uppercase font-bold text-dark-blue "
                  to="/services/training-program"
                >
                  Training Program
                </NavLink>
              </li>
              {/* <li className="py-[15px] border-b-[1px] border-dark-blue-200">
                <NavLink
                  className="text-[14px] font-roboto uppercase font-bold text-dark-blue"
                  to="/contacts"
                >
                  Contact
                </NavLink>
              </li> */}
              <li className="py-[15px] border-b-[1px] border-dark-blue-200">
                <NavLink
                  className="text-[14px] font-roboto uppercase font-bold text-dark-blue"
                  to="/blog"
                >
                  Blog
                </NavLink>
              </li>
              <li className="py-[15px]">
                <a href={ourProfilePdf} download className="group relative flex items-center text-[19px] font-normal tracking-[1px] mb-1 border rounded-lg px-3 py-2 h-fit bg-dark-blue text-white-#fff hover:bg-blue-400 hover:text-white-#fff transition duration-300 w-[175px]">

                  <svg className="fill-white-#fff group-hover:fill-white-#fff me-2" width="30px" height="30px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" >
                    <g id="SVGRepo_bgCarrier" stroke-width="0" />
                    <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" />
                    <g id="SVGRepo_iconCarrier"> <path d="M12 6.25C12.4142 6.25 12.75 6.58579 12.75 7V12.1893L14.4697 10.4697C14.7626 10.1768 15.2374 10.1768 15.5303 10.4697C15.8232 10.7626 15.8232 11.2374 15.5303 11.5303L12.5303 14.5303C12.3897 14.671 12.1989 14.75 12 14.75C11.8011 14.75 11.6103 14.671 11.4697 14.5303L8.46967 11.5303C8.17678 11.2374 8.17678 10.7626 8.46967 10.4697C8.76256 10.1768 9.23744 10.1768 9.53033 10.4697L11.25 12.1893V7C11.25 6.58579 11.5858 6.25 12 6.25Z" /> <path d="M7.25 17C7.25 16.5858 7.58579 16.25 8 16.25H16C16.4142 16.25 16.75 16.5858 16.75 17C16.75 17.4142 16.4142 17.75 16 17.75H8C7.58579 17.75 7.25 17.4142 7.25 17Z" /> <path fill-rule="evenodd" clip-rule="evenodd" d="M11.9426 1.25C9.63423 1.24999 7.82519 1.24998 6.4137 1.43975C4.96897 1.63399 3.82895 2.03933 2.93414 2.93414C2.03933 3.82895 1.63399 4.96897 1.43975 6.41371C1.24998 7.82519 1.24999 9.63423 1.25 11.9426V12.0574C1.24999 14.3658 1.24998 16.1748 1.43975 17.5863C1.63399 19.031 2.03933 20.1711 2.93414 21.0659C3.82895 21.9607 4.96897 22.366 6.4137 22.5603C7.82519 22.75 9.63423 22.75 11.9426 22.75H12.0574C14.3658 22.75 16.1748 22.75 17.5863 22.5603C19.031 22.366 20.1711 21.9607 21.0659 21.0659C21.9607 20.1711 22.366 19.031 22.5603 17.5863C22.75 16.1748 22.75 14.3658 22.75 12.0574V11.9426C22.75 9.63423 22.75 7.82519 22.5603 6.41371C22.366 4.96897 21.9607 3.82895 21.0659 2.93414C20.1711 2.03933 19.031 1.63399 17.5863 1.43975C16.1748 1.24998 14.3658 1.24999 12.0574 1.25H11.9426ZM3.9948 3.9948C4.56445 3.42514 5.33517 3.09825 6.61358 2.92637C7.91356 2.75159 9.62177 2.75 12 2.75C14.3782 2.75 16.0864 2.75159 17.3864 2.92637C18.6648 3.09825 19.4355 3.42514 20.0052 3.9948C20.5749 4.56445 20.9018 5.33517 21.0736 6.61358C21.2484 7.91356 21.25 9.62178 21.25 12C21.25 14.3782 21.2484 16.0864 21.0736 17.3864C20.9018 18.6648 20.5749 19.4355 20.0052 20.0052C19.4355 20.5749 18.6648 20.9018 17.3864 21.0736C16.0864 21.2484 14.3782 21.25 12 21.25C9.62177 21.25 7.91356 21.2484 6.61358 21.0736C5.33517 20.9018 4.56445 20.5749 3.9948 20.0052C3.42514 19.4355 3.09825 18.6648 2.92637 17.3864C2.75159 16.0864 2.75 14.3782 2.75 12C2.75 9.62178 2.75159 7.91356 2.92637 6.61358C3.09825 5.33517 3.42514 4.56445 3.9948 3.9948Z" /> </g>

                  </svg>
                  <span className=" ">Our Profile</span>

                </a>
              </li>
            </ul>
          </div>

          {/* <div className="hidden lg:block"><a className="inline-block py-3 px-8 text-sm leading-normal font-medium bg-red-50 hover:bg-red-100 text-red-500 rounded transition duration-200" href="#">Contact Us</a></div> */}
        </nav>
        <p className="font-work-sans text-f15 mb-9 ">
          ISO 9001:2015, ISO 14001:2015, ISO 45001:2018, ISO 17020:2012 (NABL),
          ISO 17025:2017 (BAB) Certified Company
        </p>
        <div
          className={`${isSticky ? "sticky" : ""
            } relative z-20 hidden xl:block bg-blue-400 `}
        >
          <div className="triangle"></div>
          <ul className="flex justify-around items-center font-roboto xl:p-1">
            <NavLink
              to="/"
              className="py-3 text-f14 px-6 uppercase font-bold text-white-#fff z-10"
            >
              Home
            </NavLink>
            <NavLink
              to="/about-us"
              className="py-3 text-f14 px-6 uppercase font-bold text-white-#fff "
            >
              About Us
            </NavLink>
            <NavLink
              to="/services/inspection"
              className="py-3 text-f14 px-6 uppercase font-bold text-white-#fff "
            >
              Inspection
            </NavLink>
            <NavLink
              to="/services/calibration"
              className="py-3 text-f14 px-6 uppercase font-bold text-white-#fff"
            >
              Calibration
            </NavLink>
            <NavLink
              to="/services/testing"
              className="py-3 text-f14 px-6 uppercase  font-bold text-white-#fff"
            >
              Testing Services
            </NavLink>
            <NavLink
              to="/services/training-program"
              className="py-3 text-f14 px-6 uppercase  font-bold text-white-#fff"
            >
              Training Program
            </NavLink>
            {/* <NavLink
              to="/contacts"
              className="py-3 text-f14 px-6 uppercase  font-bold text-white-#fff"
            >
              Contact
            </NavLink> */}
            <NavLink
              to="/report-verify"
              className="py-3 text-f14 px-6 uppercase  font-bold text-white-#fff"
            >
              Report Verify
            </NavLink>

            <NavLink
              to="/blog"
              className="py-3 text-f14 px-6 uppercase  font-bold text-white-#fff"
            >
              Blog
            </NavLink>
          </ul>
        </div>
      </header>
    </div>
  );
};

export default Header;
